'use client';

import { c as _c } from "react/compiler-runtime";
import { motion } from 'framer-motion';
interface TrustItem {
  label: string;
  id: string;
}
const TRUST_ITEMS: TrustItem[] = [{
  label: '✓ Enrollment required',
  id: 'item-1'
}, {
  label: '✓ Clear earnings model',
  id: 'item-2'
}, {
  label: '✓ Keep ownership of your content',
  id: 'item-3'
}, {
  label: '✓ Non-exclusive publishing',
  id: 'item-4'
}, {
  label: '✓ No AI Training*',
  id: 'item-5'
}];
const SEPARATOR = '•';
const ITEMS_TO_SHOW = 3;
export default function TrustStrip() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    const duplicatedItems = Array.from({
      length: ITEMS_TO_SHOW
    }, _temp).flat();
    t0 = <div className="relative z-floating w-full overflow-hidden border-t border-b border-[rgba(213,226,242,0.08)] bg-[rgba(33,42,57,0.4)] px-0 py-[18px] backdrop-blur-xl"><motion.div className="flex gap-8 whitespace-nowrap" animate={{
        x: "-33.333%"
      }} transition={{
        duration: 20,
        repeat: Infinity,
        ease: "linear"
      }}>{duplicatedItems.map(_temp2)}</motion.div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp2(item, index) {
  return <div key={`${item.id}-${index}`} className="flex shrink-0 items-center gap-8"><span className="text-base font-semibold tracking-[0.2px] text-white">{item.label}</span><span className="text-base text-[rgba(115,234,255,0.2)]">{SEPARATOR}</span></div>;
}
function _temp() {
  return TRUST_ITEMS;
}